'use strict';

String.prototype.insertAt = function(pos, what) {
    return [this.slice(0, pos), what, this.slice(pos)].join('');
};

if (!String.prototype.format) {
    String.prototype.format = function() {
        var args = (arguments.length === 1 && $.isArray(arguments[0])) ? arguments[0] : arguments;
        var formattedString = this;
        for (var i = 0; i < args.length; i++) {
            var pattern = new RegExp("\\{" + i + "\\}", "gm");
            formattedString = formattedString.replace(pattern, args[i]);
        }
        return formattedString;
    };
}

if (!String.prototype.capitalize) {
    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };
}

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' && 
        isFinite(value) && 
        Math.floor(value) === value;
};

if (!String.prototype.startsWith) {
      String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(search, replacement) {
        return this.split(search).join(replacement);
    };
}

if (!String.prototype.defaultLocaleCompare) {
    String.prototype.defaultLocaleCompare = String.prototype.localeCompare;
    String.prototype.localeCompareRegExp = new RegExp('(.*[^\\d])(\\d+)$');
    String.prototype.localeCompare = function(compareString, locales, options) {
        if (this.length && this[this.length-1] >= '0' && this[this.length-1] <= '9') {
            if (compareString && compareString.length && compareString[compareString.length-1] >= '0' && compareString[compareString.length-1] <= '9') {
                var ar = this.match(String.prototype.localeCompareRegExp);
                var br = compareString.match(String.prototype.localeCompareRegExp);
                if (ar && br) {
                    if (ar[1] == br[1]) {
                        var res = Number(ar[2]) - Number(br[2]);
                        return res == 0 ? 0 : (res < 0 ? -1 : 1);
                    }
                }
            }
        }
        return this.defaultLocaleCompare(compareString, locales, options);
    };
}
